import React, { useEffect, useRef } from "react";
import "../../../assets/css/Text.css";
import "../../../assets/css/InputText.css";
import InputLabel from "./inputLabel";
import Percentage from "../Icons/Percentage";

interface InputProps {
  title: string;
  name?: string;
  errorMsj?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error: boolean;
  isWfull?: boolean;
  tooltip?: string;
  type?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onClick?: () => void;
  className?: string;
  percentage?: boolean;
  labelClass?: string;
  inputClass?: string
}

const NUMBER_INPUT_NO_SPINNER_CLASSNAME =
  "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";

const Input: React.FC<InputProps> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (!el || props.type !== "number") {
      return;
    }
    const onWheel = (e: WheelEvent) => {
      e.preventDefault();
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, [props.type]);

  return (
    <div
      className={`${props?.inputClass} flex flex-col gap-2 md:gap-[.625rem] w-full h-full`}
    >
      {(props.title || props.tooltip) && (
        <div className="flex gap-2.5 w-full">
          <InputLabel
            name={props.name ?? ""}
            title={props.title}
            required={props.required}
            tooltip={props.tooltip}
            labelClass={props.labelClass}
          />
        </div>
      )}
      <div className="relative w-full">
        <input
          ref={inputRef}
          name={props.name}
          id={props.name}
          value={props.value || ""}
          placeholder={props.placeholder}
          onChange={props.onChange}
          autoComplete={props.name}
          type={props.type ?? "text"}
          disabled={props.disabled}
          onClick={props.onClick}
          className={`${props.inputClass} w-full ${props.error ? "errorInput text-primary" : "text-input-gray"} ${props.type === "number" ? NUMBER_INPUT_NO_SPINNER_CLASSNAME : ""} ${props.className ?? ""}`}
        />
        {props.percentage && (
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
            <Percentage className={`w-6 h-6 ${props.disabled ? "text-gray-200" : "text-input-gray"}`} />
          </span>
        )}
      </div>

      {props.errorMsj && <span
        className={`flex flex-wrap items-center text-base font-medium text-primary`}
      >
        {props.errorMsj}
      </span>}
    </div>
  );
};

export default Input;
